import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=58bc6238&scoped=true&lang=pug"
import script from "./PackageItem.vue?vue&type=script&lang=ts"
export * from "./PackageItem.vue?vue&type=script&lang=ts"
import style0 from "./PackageItem.vue?vue&type=style&index=0&id=58bc6238&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc6238",
  null
  
)

export default component.exports